import slice from './slice';

export const { actions, reducer } = slice;
